import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { DocumentClient, Documents, DocumentTypeClient, DocumentTypes, Material, MaterialClient, MechanisationClient, Mechanisations, NServices, ServiceClient, Unit, VIKUnitClient} from "src/app/web-api-client";
import { forkJoin } from "rxjs";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap"; 
import { MechanisationCreationComponent } from "./mechanisation-creation/mechanisation-creation.component";
import { MechanisationEditComponent } from "./mechanisation-edit/mechanisation-edit.component";
import { ConfirmModalComponent } from "../../../../modals/confirm-modal/confirm-modal.component";
import { UnSuccessModalComponent } from "../../../../modals/failed-modal/failed-modal.component";


@Component({
  selector: 'app-mechanisation',
  templateUrl: './mechanisation.component.html',
  styleUrls: ['./mechanisation.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class MechanisationComponent implements OnInit {

  public isLoaded: boolean = false;
  public selectedService: Mechanisations;
  public services: Mechanisations[]; 

  public searchQuery: string = '';
  public filteredServices: Mechanisations[] = [];


  constructor(private readonly changeDetectionRef:ChangeDetectorRef, private readonly modalService: NgbModal,public client:MechanisationClient){

  }

  ngOnInit(): void {

    this.LoadData();

    //this.client.getList().subscribe((allDocs:Documents[])=>{
    //  this.services = allDocs;
    //  this.isLoaded = true;
    //  this.changeDetectionRef.detectChanges();
    //});

  }

  private LoadData() {
    this.isLoaded = false;
        forkJoin([this.client.getList()])
            .subscribe(([documents]) => {

              this.services = documents;
              this.filteredServices = documents; 

                this.isLoaded = true;
                this.changeDetectionRef.detectChanges();

            });
    }

 

 public onSelected(service:Material){
   if (this.isSelected(service)){
    this.selectedService = null;
  }
  else{

     this.selectedService = service;
  }
 }

  public isSelected(service: Material):boolean{
   return this.selectedService == service;
 }

public onCreation():void{
  let modalRef =this.modalService.open(MechanisationCreationComponent, {});

  modalRef.componentInstance.onClose.subscribe(r => {

    this.LoadData();

  });

}


public onDelete(): void { 
  let modalRef = this.modalService.open(ConfirmModalComponent);

  modalRef.componentInstance.onClose.subscribe(result => {
    if (result === true) {

      this.client.remove(this.selectedService.id).subscribe(r => {
        this.services = this.services.filter(d => d.id != this.selectedService.id);
        this.filteredServices = this.services.slice(0);
        this.changeDetectionRef.detectChanges();
      })
    }
    else {
      this.modalService.open(UnSuccessModalComponent);
    }
  });

  }

  public onEdit(): void {

    let modalRef = this.modalService.open(MechanisationEditComponent);
    modalRef.componentInstance.editObject = this.selectedService;

    modalRef.componentInstance.onClose.subscribe(r => {

      this.LoadData();

    });
    }
     

  public GetBoolean(val: boolean): string {

    return val ? 'Да' : 'Не';
    
  }

  filterServices() {
    if (this.searchQuery) {
      this.filteredServices = this.services.filter(service =>
        service.title.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        service.description.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        service.isActive.toString().toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    } else {
      this.filteredServices = this.services;
    }
  }
   
}
